import { createLinkExpiry } from "api/configuration";
import { handleEmailNotification,triggerSMSInvite } from "./callbacks";
import { getOrgInfo } from "api/organisation";


export const triggerButtonCallback = async (callback, dispatch) => {
  const { type, link, organisation_id, has_link_expiry, trigger } = callback;
  if (has_link_expiry) {
    await getOrgInfo({ _id: organisation_id }).then(async (res) => {
      if (res?.setting?.link_expiry_duration_in_hours) {
        const linkExpiryObjectID = await dispatch(
          createLinkExpiry({
            organisation_id: organisation_id,
            type: trigger ? String(trigger) : "Invite Customer",
            hours: res?.setting?.link_expiry_duration_in_hours,
            // has_link_expiry: res?.has_link_expiry,
          })
        ).unwrap();
        let emailLink = "";
        if (linkExpiryObjectID) {
          if (link?.includes("token=")) {
            emailLink = link.replace(/token=[^&]+/, linkExpiryObjectID?.data);
          } else {
            const separator = link?.includes("?") ? "&" : "?";
            emailLink = `${link}${separator}${linkExpiryObjectID?.data}`;
          }
        }
        callback.link = emailLink;
      }
    });
  }
  let recipientName;
  if (callback?.last_name) {
    recipientName = callback?.first_name + " " + callback?.last_name;
  } else recipientName = callback?.first_name;
  callback.recipientName = recipientName;
  switch (type) {
    case "email":
      handleEmailNotification(callback);
      break;
    case "sms":
      triggerSMSInvite(callback);
        break;
    default:
      break;
  }
};

export const mergeFields = (data,extractedData,keyName,dispatch,setSelectedData) => {
  let value =''
  if(extractedData){
    extractedData = extractedData.replace(/[^a-zA-Z0-9,:]/g, ' ');
    value = extractedData
  }else{
  data.forEach(element => {
    if(element != null || element != undefined ){
      if(element.length !=0) value = value + element + ', '
    }
  });
  value = value.slice(0,-2)
}
  dispatch(setSelectedData({key : keyName, value:value}))
   
};
